import { MutableRefObject, useEffect } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { useGetVendorReleaseRecentInfo, useOption } from '~/hooks/stock';
import { useStockReleaseStore } from '~/store';
import { formatTel } from '~/utils';

import { STOCK_CODES, STOCK_RELEASE_PALLET_INFO_REQUIRED_CODES } from '~/constants';

import StockReleaseRegisterAgreeInfo from './StockReleaseRegisterAgreeInfo';
import StockReleaseRegisterDetailInfo from './StockReleaseRegisterDetailInfo';
import StockReleaseRegisterPalletInfo from './StockReleaseRegisterPalletInfo';

import { TypeStockReleaseRegisterErrorFieldRefs } from '~/types/stock.types';

import styles from './StockReleaseRegisterSecondStepContent.module.scss';

/**
 * [재고관리 > 반출요청관리] 반출요청등록 모달 > STEP 2
 */
const StockReleaseRegisterSecondStepContent = ({
  errorFieldRefs,
}: {
  errorFieldRefs: MutableRefObject<TypeStockReleaseRegisterErrorFieldRefs>;
}) => {
  const { options } = useOption({
    codes: [
      STOCK_CODES.vendorReleaseMethod,
      STOCK_CODES.vendorReleasePackingMethod,
      STOCK_CODES.vendorReleasePalletType,
    ],
  });

  const { detailInfo, setRecentInfo } = useStockReleaseStore(
    useShallow((state) => ({
      detailInfo: state.detailInfo,
      setRecentInfo: state.actions.setRecentInfo,
    }))
  );

  const { requestVendorReleaseRecentInfo, responseData: stockReleaseRecentInfo } = useGetVendorReleaseRecentInfo();

  useEffect(() => {
    requestVendorReleaseRecentInfo();
  }, []);

  useEffect(() => {
    if (options?.vendorReleasePalletType && stockReleaseRecentInfo) {
      setRecentInfo({
        destinationAddress: stockReleaseRecentInfo.destinationAddress
          ? {
              ...stockReleaseRecentInfo.destinationAddress,
              phoneNumber: formatTel(stockReleaseRecentInfo.destinationAddress.phoneNumber ?? ''),
            }
          : null,
        palletInfo: stockReleaseRecentInfo.palletInfo
          ? {
              ...stockReleaseRecentInfo.palletInfo,
              managerPhoneNumber: formatTel(stockReleaseRecentInfo.palletInfo.managerPhoneNumber ?? ''),
            }
          : null,
      });
    }
  }, [options?.vendorReleasePalletType, stockReleaseRecentInfo, setRecentInfo]);

  return (
    <div className={styles['contents-container']}>
      <StockReleaseRegisterDetailInfo errorFieldRefs={errorFieldRefs} options={options} />
      {STOCK_RELEASE_PALLET_INFO_REQUIRED_CODES.includes(detailInfo?.packingMethod ?? '') && (
        <StockReleaseRegisterPalletInfo errorFieldRefs={errorFieldRefs} options={options} />
      )}
      <StockReleaseRegisterAgreeInfo errorFieldRefs={errorFieldRefs} />
    </div>
  );
};

export default StockReleaseRegisterSecondStepContent;
